const highlight = (modifier) => (searchQuery, fullString) => {
  if (typeof searchQuery !== 'string' || typeof fullString !== 'string') {
    return fullString;
  }

  const regExp = new RegExp(searchQuery, 'ig');

  let regExpHasValue = true;
  let resString = '';
  let lastMatchPos = 0;

  while (regExpHasValue) {
    const match = regExp.exec(fullString);

    if (match) {
      const matchQuery = match[0];
      const modifiedMatch = modifier(matchQuery);

      const startMatchPos = match.index;
      const endMatchPos = regExp.lastIndex;

      resString = `${resString}${fullString.substring(
        lastMatchPos,
        startMatchPos,
      )}${modifiedMatch}`;
      lastMatchPos = endMatchPos;
    } else {
      resString = resString + fullString.substring(lastMatchPos, fullString.length);
      regExpHasValue = false;
    }
  }

  return resString;
};

export default highlight;
